import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description Action sub button component.
 * @param String id: Button identifier (required).
 * @param String name: Name of the model that receives the button (required).
 * @param String className: Style class for the button or default styles (optional).
 * @param Boolean disabled: Variable to disable the button (required).
 * @param event onClick: Click event (required).
 * @param String url: Navigation URL (optional).
 * @param {JSX.Element} Icon: Icon component (optional).
 * @param String iconProps: Two style classes for the icon, one for size and another for color, or default styles initialized
 * @returns {JSX.Element}
 */
const ButtonActionsCard = (props) => {
    const { id = 'btn_bac_btn_actions_card', name, className = 'btn-icon-hover-grey', disabled = false, onClick = null, url = '', Icon, iconProps = 'btn-icon-svg-12px btn-icon-svg-green' } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <button
            id={id}
            className={`btn-href-btn-card text-capitalize ${className}`}
            disabled={disabled}
            onClick={(e) => {
                if (onClick !== null) onClick(e);
                if (url != '') navigate(url);
            }}
        >
            {t(name)}
            {Icon && <Icon className={`ml-2 font-title ${iconProps}`} />}
        </button>
    );
};

export default ButtonActionsCard;
